export const TEXTS = {
  SBER_ID_TEXT: 'Авторизация по СберБизнес ID',
  SBER_ID_DISABLED_TEXT: 'Сбер ID подключен',
  SBER_ID_HINT: 'Для доступа к спецпредложениям Сбербанка',
  SBER_ID_REAUTH_START_TEXT: 'СберБизнес ID подключается. Ожидайте',
  SBER_ID_REAUTH_SUCCESS_TEXT: 'Сбер ID подключен. Проверяем доступность спецпредложений Сбербанка',
  SBER_ID_REAUTH_ERROR_TEXT: 'При подключении Сбер ID произошла ошибка. Попробуйте еще раз',
};
